module.exports = __webpack_public_path__ + "static/media/security.8e64f43b.svg";